<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item>系统配置</el-breadcrumb-item> -->
            <el-breadcrumb-item>日常出勤</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!--  -->
          <div class="build-table">
            <div
              style="display:flex;border-top:10px solid #f5f5f5;width:100%;height:80px;align-items:center;padding:0px 10px"
            >
              <el-date-picker
                v-model="time"
                @change="doFilter"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width:130px;font-size:12px"
              ></el-date-picker>
              <!-- 是否出勤 -->
              <el-select
                v-model="flag"
                popper-class="fen-sel"
                class="fen-val"
                placeholder="选择是否出勤"
                style="margin-left:20px"
              >
                <el-option
                  v-for="item in isAttend"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-model="search.name"
                placeholder="请输入人员姓名"
                clearable
                @input="watchInput"
                style="width:220px;padding:10px"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>

            <!--  -->
            <div style="width:100%;height:calc(100% - 140px)">
              <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399',}"
                :cell-style="rowClass"
                @row-click="openDetails"
                border
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column>

                <el-table-column label="日期">
                  <template slot-scope="scope">
                    <a>{{ scope.row.maxDate}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="人员姓名" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="部门" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.officeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="当日首次上线时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.minTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="当日末次上线时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.maxTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注">
                  <template slot-scope="scope">
                    <span style="margin-right:20px;width:50px">{{ scope.row.remarks }}</span>
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click.native.stop="handleEdit(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click.native.stop="handleEdit(scope.$index, scope.row)"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click.native.stop="handleDel(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>-->
              </el-table>
              <!-- 添加公告弹框 -->
              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                width="800px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form
                  :model="addForm"
                  label-width="200px"
                  ref="addForm"
                  label-position="right"
                  :rules="rules"
                >
                  <el-form-item label="备注" prop="remarks">
                    <el-input v-model="addForm.remarks" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </div>
            <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10,20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        name: '',
      },
      listData: [], //表格数据
      addForm: {
        remarks: '',
        time: '',
        userId: '',
      },
      dialogTitle: '',
      addFormVisible: false,
      groupId: '',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      storeOpt: [], //题库

      dataText: '数据加载中...',
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      groupType: '',
      groupId: '',
      createBy: util.session.get('user').id,
      uploadphotoUrl: base.url + '/upload/uploadPhotosAndThumbnail',
      uploadHead: {
        accessToken: util.session.get('token'),
      },
      uploadphotoData: {
        type: '221',
      },
      type: 1,
      dialogImageUrl: '',
      dialogVisible: false,
      photoList: [], //多张普通图片
      photoThum: [], //多张缩略图
      isAttend: [
        { name: '全部', value: '1' },
        { name: '是', value: '2' },
        { name: '否', value: '3' },
      ],
      flag: '1',
      time: util.myTime.getCurTime(),
      personName: '',
    }
  },

  mounted() {
    this.groupId = util.session.get('groupId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    this.search.groupId = this.groupId
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.groupType = '2'
    }
    // console.log(this.groupId)
    this.getData()
  },
  methods: {
    //查询
    doFilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    // 获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      this.search.time = this.time
      this.search.flag = this.flag
      this.search.personName = this.personName
      myHttp.pageInfoEntPersonAttend(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.entPersonAttends.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.totalItems = resp.data.data.entPersonAttends.total || 0
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
    },
    watchInput(e) {
      this.personName = e
    },
    openDetails() {},
    handleEdit(index, row) {
      this.dialogTitle = '修改备注'
      this.addForm.remarks = ''
      this.addFormVisible = true
      this.addForm.time = row.maxDate
      this.addForm.userId = row.userId
    },
    //
    //保存
    sumbitAddRow(formName) {
      var that = this
      this.addForm.entId = this.groupId
      // this.addForm.groupType = this.groupType
      this.addForm.createBy = this.createBy
      // console.log(this.addForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myHttp.createOrUpdate(that.addForm).then(function (resp) {
            if (resp.data.code == '200') {
              that.addFormVisible = false
              that.$message.success('操作成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      })
    },
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
.content >>> .el-table tr {
  cursor: pointer;
}
</style>